<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b v-if="atualizacao">Atualizar Comunicado</b>
                            <b v-else>Novo Comunicado</b>
                        </h3>
                    </div>
                    <div class="box-body">
                        <div class="row">
							<div class="col-md-6" :class="{ 'has-error': showTextDangerTitulo }">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerTitulo }">Título</label>
                                    <input v-model="dados.titulo" class="form-control" type="text" />
                                </div>
                            </div>
                            <div class="col-md-2" :class="{ 'has-error': showTextDangerDataInicial }">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerDataInicial }">Data Inicial</label>
                                    <input v-model="dados.data_inicial" class="form-control" type="date" />
                                </div>
                            </div>
                            <div class="col-md-2" :class="{ 'has-error': showTextDangerDataFinal }">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerDataFinal }">Data Final</label>
                                    <input v-model="dados.data_final" class="form-control" type="date" />
                                </div>
                            </div>
							<div class="col-md-2">
                                <div class="form-group" :class="{ 'has-error': showTextDangerSituacao }">
                                    <label :class="{ 'erro-validacao': showTextDangerSituacao }">Situação</label>
                                    <select v-model="dados.situacao" class="form-control">
                                        <option value="ATIVO">Ativo</option>
                                        <option value="INATIVO">Inativo</option>
                                    </select>
                                </div>
                            </div>
							<div class="col-md-12">
								<div class="form-group" :class="{ 'has-error': showTextDangerDescricao }">
									<label :class="{ 'erro-validacao': showTextDangerDescricao }">Descrição</label>
									<vue-editor v-model="dados.descricao"></vue-editor>
								</div>
							</div>
							<div class="col-md-6">
                                <div class="form-group">
									<label>Visível para</label><br/>
									<input v-model="dados.marcador_visualiza" type="checkbox"> Marcadores
									<input v-model="dados.prestador_visualiza" style="margin-left: 3.5em;" type="checkbox"> Prestadores
									<input v-model="dados.regulador_visualiza" style="margin-left: 3.5em;" type="checkbox"> Reguladores
									<input v-model="dados.administrador_visualiza" style="margin-left: 3.5em;" type="checkbox"> Administradores
								</div>
                            </div>
                        </div>
                        <div class="row">

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <button @click="salvar()" class="btn btn-primary pull-right" type="button"><i class="fa fa-save"></i> Salvar</button>
                                <button class="btn btn-default pull-left" @click="$router.go(-1)"><i class="fa fa-close"></i> Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import { VueEditor } from "vue2-editor";

export default {
    filters: {},
    data: () => ({
        atualizacao: false,
		showTextDangerTitulo: false,
        showTextDangerDataInicial: false,
        showTextDangerDataFinal: false,
        showTextDangerSituacao: false,
		showTextDangerDescricao: false,

        dados: {
			titulo: "",
            data_inicial: "",
            data_final: "",
			descricao: "",
            situacao: 'ATIVO',
			marcador_visualiza: true,
			prestador_visualiza: true,
			regulador_visualiza: true,
			administrador_visualiza: true,
        }
    }),
    mounted() {
        if (this.$route.params.comunicado_id) {
            this.getById(this.$route.params.comunicado_id);
            this.atualizacao = true;
        }
    },
    methods: {
        salvar() {
            if (this.validar()) {
                if (this.atualizacao) {
                    axios
                        .post(`${this.$store.state.serverURI}/api/administracao/comunicados/${this.dados.id}`, this.dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Comunicado atualizado com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.$router.go(-1);
                        })
                        .catch(error => {
                            var erros = error.response.data.message + " ";
                            for (var erro of Object.values(error.response.data.errors)) {
                                erros += erro + " \n";
                            }
                            this.$swal({
                                type: "error",
                                title: "Houve uma falha!",
                                text: erros
                            });
                        });
                } else {
                    axios
                        .post(`${this.$store.state.serverURI}/api/administracao/comunicados`, this.dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    type: "success",
                                    title: response.data.msg,
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                                this.$router.go(-1);
                            } else {
                                this.$swal({
                                    type: "error",
                                    title: response.data.titulo_msg,
                                    text: response.data.msg,
                                    showConfirmButton: true
                                }).then(() => {
                                    this.$router.go(-1);
                                });
                            }
                        })
                        .catch(error => {
                            var erros = error.response.data.message + " ";
                            for (var erro of Object.values(error.response.data.errors)) {
                                erros += erro + " \n";
                            }
                            this.$swal({
                                type: "error",
                                title: "Houve uma falha!",
                                text: erros
                            });
                        });
                }
            } else {
                this.$swal({
                    type: "error",
                    title: "Informações pendentes",
                    text: "Preencha corretamente os campos destacados em vermelho!"
                });
            }
        },

        getById(comunicadoId) {
            this.$store.commit("TOGGLE_LOADING");
            axios
                .get(`${this.$store.state.serverURI}/api/administracao/comunicados/${comunicadoId}`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.dados = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    console.log(error);
                });
        },

        validar() {
            let validou = true;
			if (this.dados.titulo === "") {
                this.showTextDangerTitulo = true;
                validou = false;
            }
			if (this.dados.descricao === "") {
                this.showTextDangerDescricao = true;
                validou = false;
            }
            if (this.dados.data_inicial === "") {
                this.showTextDangerDataInicial = true;
                validou = false;
            }
            if (this.dados.data_final === "") {
                this.showTextDangerDataFinal = true;
                validou = false;
            }
            if (this.dados.situacao === "") {
                this.showTextDangerSituacao = true;
                validou = false;
            }

            return validou;
        }
    },
    components: {
		VueEditor
	}
};
</script>
<style>
.erro-validacao {
    color: #d73925;
}
</style>



// WEBPACK FOOTER //
// form.vue?6b3459dc